<template>
  <f7-searchbar
    :ref="id"
    expandable
    custom-search
    placeholder="Buscar"
    :backdrop="false"
    @searchbar:search="buscar"
    @searchbar:disable="resetearBusqueda"
  ></f7-searchbar>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['catalogo', 'filtros', 'activarBusqueda', 'id'],
  data () {
    return {
      init: false,
      catalogoFiltrado: [],
      catalogoFiltradoBuscar: [],
      catalogoDespleagado: [],
      delayBusqueda: null,
      cargaInfinita: true,
      omitir: ['image', 'img_ext', 'cve', 'idc_articles', 'num_stones', 'Price', 'id'],
      busquedaPorPalabra: false
    }
  },
  watch: {
    activarBusqueda (val) {
      if (val) {
        // this.$refs[this.id].enable()
        this.$f7.searchbar.toggle(this.$refs[this.id].$el)
      }
    },
    catalogo (val) {
      this.aplicarFiltro()
    },
    catalogoFiltrado (val) {
      if (val === null) { this.catalogoFiltrado = [] }
    },
    filtros: {
      deep: true,
      handler (value) {
        if (value.length) {
          this.aplicarFiltro()
        }
      }
    }
  },
  methods: {
    aplicarFiltro () {
      let arr = []

      if (this.busquedaPorPalabra) {
        this.catalogoFiltrado = this.catalogoFiltradoBuscar
        arr = this.catalogoFiltradoBuscar
      } else {
        this.catalogoFiltrado = this.catalogo
        arr = this.catalogo
      }

      this.filtros.forEach(filtro => {
        if (filtro.negated) {
          if (filtro.value !== '*') {
            this.catalogoFiltrado = arr
              .filter(item => item[filtro.prop].toLowerCase() !== filtro.value.toLowerCase())
            arr = this.catalogoFiltrado
          }
        } else if (filtro.regex && filtro.value) {
          this.catalogoFiltrado = arr
            .filter(item => filtro.regex.test(item[filtro.prop]))
          arr = this.catalogoFiltrado
        } else if (filtro.value) {
          if (filtro.value !== '*') {
            this.catalogoFiltrado = arr
              .filter(item => {
                if (isNaN(item[filtro.prop]) && isNaN(filtro.value)) {
                  return item[filtro.prop].toLowerCase() === filtro.value.toLowerCase()
                } else {
                  return item[filtro.prop] === filtro.value
                }
              })
            arr = this.catalogoFiltrado
          }
        } else {
          if (filtro.prop.toLowerCase() === 'price' || filtro.prop.toLowerCase() === 'carat') {
            let reajuste = 0
            if (filtro.prop.toLowerCase() === 'price') { reajuste = 1 }
            this.catalogoFiltrado = arr
              .filter(item => Number(item[filtro.prop]) >= Number(filtro.minValue) - reajuste && Number(item[filtro.prop]) <= Number(filtro.maxValue))
            arr = this.catalogoFiltrado
          } else if (filtro.prop.toLowerCase() === 'color') {
            this.catalogoFiltrado = arr
              .filter(item => this.$helper.arr.entre(
                ['M', 'L', 'K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'].reverse().indexOf(item[filtro.prop]),
                filtro.minValue,
                filtro.maxValue)
              )
            arr = this.catalogoFiltrado
          } else if (filtro.prop.toLowerCase() === 'clarity') {
            this.catalogoFiltrado = arr
              .filter(item => this.$helper.arr.entre(
                ['I3', 'I2', 'I1', 'SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'].reverse().indexOf(item[filtro.prop]),
                filtro.minValue,
                filtro.maxValue)
              )
            arr = this.catalogoFiltrado
          } else if (filtro.prop.toLowerCase() === 'makecutgrade') {
            let noMakeCutGrade = this.catalogoFiltrado
              .filter(item => item.MakeCutGrade.trim() === '')
            this.catalogoFiltrado = arr
              .filter(item => this.$helper.arr.entre(
                ['EX', 'VG', 'G', 'F'].indexOf(item[filtro.prop]),
                filtro.minValue,
                filtro.maxValue)
              )

            arr = [...this.catalogoFiltrado, ...noMakeCutGrade]
          } else if (filtro.prop.toLowerCase() === 'tejido') {
            if (filtro.name !== '*') {
              this.catalogoFiltrado = arr
                .filter(item => item.type.toLowerCase().includes(filtro.name))
              arr = this.catalogoFiltrado
            }
          } else if (filtro.prop.toLowerCase() === 'estilo') {
            if (filtro.name !== '*') {
              this.catalogoFiltrado = arr
                .filter(item => item.type.toLowerCase().includes(filtro.name))
              arr = this.catalogoFiltrado
            }
          } else if (filtro.prop.toLowerCase() === 'solitario') {
            if (filtro.value !== '*') {
              this.catalogoFiltrado = arr
                .filter(item => item.stones_1 === filtro.value)
              arr = this.catalogoFiltrado
            }
          } else if (filtro.prop.toLowerCase() === 'laterales') {
            if (filtro.value !== '*') {
              this.catalogoFiltrado = arr
                .filter(item => item.stones_1 !== 0)
              arr = this.catalogoFiltrado
            }
          }
        }
      })

      this.catalogoFiltrado = arr
      
      this.catalogoDespleagado = _.slice(this.catalogoFiltrado, 0, 20)
      this.$emit('search:load-complete', this.catalogoDespleagado)
      this.$emit('search:data', this.catalogoFiltrado)
    },
    buscar (searchbar, query, previousQuery) {
      if (!this.catalogo) { return }
      if (searchbar.value.length > 1) {
        this.$emit('search:active', true)
      } else {
        this.$emit('search:active', false)
      }

      let queries = query.split(' ')
      clearTimeout(this.delayBusqueda)

      this.delayBusqueda = setTimeout(() => {
        if (queries.length) {
          let arr = this.catalogo
          this.catalogoFiltradoBuscar = []

          queries.forEach((q, idx) => {
            this.catalogoFiltradoBuscar = arr
              .filter(item => Object.values(_.omit(item, this.omitir))
                .some(itm => String(itm)
                  .toLowerCase()
                  .includes(q.toLowerCase())))
            arr = this.catalogoFiltradoBuscar
          })
          this.busquedaPorPalabra = true
          this.aplicarFiltro()
        }
      }, 100)
    },
    cargar () {
      if (this.cargaInfinita) {
        this.cargaInfinita = false

        if (this.catalogoDespleagado.length <= this.catalogoFiltrado.length) {
          const totalCargado = this.catalogoDespleagado.length
          this.catalogoDespleagado.push(..._.slice(this.catalogoFiltrado, totalCargado, totalCargado + 20))

          this.cargaInfinita = true
          this.$emit('search:load-complete', this.catalogoDespleagado)
        }
      }
    },
    resetearBusqueda () {
      this.catalogoFiltrado = this.catalogo
      this.busquedaPorPalabra = false
      this.catalogoFiltradoBuscar = []
      this.aplicarFiltro()
      this.$emit('searchbar:disable')
    }
  },
  created () {
    this.$evento.on('search:load', this.cargar)
  }
}
</script>
